import { gql } from '@apollo/client'

const INTERCOM_PERSONAL_DETAILS = gql`
  query IntercomPersonalDetailsQuery {
    user {
      id
      firstName
      lastName
      email
      numericalCreatedAt
      intercomUserHash
      trackingId
    }
  }
`

export { INTERCOM_PERSONAL_DETAILS }
